import { useContext } from 'react'

import { UserContext, type UserContextType } from '../contexts/user-context-definition'

export const useUser = (): UserContextType => {
  const context = useContext(UserContext)
  if (context === undefined) {
    throw new Error('useUser must be used within a UserProvider')
  }
  return context
}